export const BAR_GAP = 8;
export const GAP_BETWEEN_CHARTS = 20;
export const MAX_BAR_SIZE = 100;

export const BAR_COLOR = '#4E79A7';
export const BAR_COLOR2 = '#F28E2B';

export const TICK_THICKNESS = 4;


// WEBPACK FOOTER //
// ./src/components/visualizations/barcharts/default-design.ts